import {
  Modal,
  Select as EDSelect,
  Snackbar,
  Snack,
  Button,
  TextField,
} from '@nike/eds';
import { useState, useEffect, useRef, useCallback, ChangeEvent } from 'react';
import RankingListItem from './RankingListItem';
import ConceptSelect from './ConceptSelect';
import { MultiValue } from 'react-select';
import HotsearchClient from '../../clientAPI/hotsearch';
import './HotsearchRankingList.module.css';

type SelectOption = { value: Status; label: string };
type ChannelOption = { value: string; label: string };
type TypeSelectOption = { value: RankingListType; label: string };

interface ConceptOption {
  id: number;
  name: string;
}

type RankingListPreviewProps = {
  onDismiss: () => void;
  updateItem: (msg: string) => void;
  showModal: boolean;
  mode: Mode;
  canWrite: boolean;
  itemId: string;
};

type ChangeItems = {
  image: UploadFileType | null;
  isPortrait: boolean;
  itemIndex: number;
  imageUrl: string;
  preSignedUrl?: string;
  src: string;
};

export default function RankingListEdit(props: RankingListPreviewProps) {
  const channelOptions = [
    { value: '82a74ac1-c527-4470-b7b0-fb5f3ef3c2e2', label: 'Nike App' },
    { value: 'd9a5bc42-4b9c-4976-858a-f159cf99c647', label: 'Nike.COM' },
    { value: '15d92135-394e-487a-8afa-f6c8525c9ea9', label: 'WeChat' },
    { value: '008be467-6c78-4079-94f0-70e2d6cc4003', label: 'SNKRS' },
  ];

  const [itemsList, setItemsList] = useState<RankingItem[]>([]);
  const [title, setTitle] = useState<string>('');
  const [name, setName] = useState<string>('');
  const [footnote, setFootnote] = useState<string>('');
  const [ctaText, setCtaText] = useState<string>('');
  const [itemId, setItemId] = useState<string>('');
  const [customeType, setCustomeType] = useState<RankingListType>();
  const [conceptsId, setConceptsId] = useState<string[]>([]);
  const [hotSearchType, setHotSearchType] = useState<
    TypeSelectOption | undefined
  >();
  const [channel, setChannel] = useState<ChannelOption[]>();

  const titleRef = useRef<HTMLInputElement>(null);

  const nameRef = useRef<HTMLInputElement>(null);
  const [nameErrorMsg, setNameErrorMsg] = useState('');
  const [nameError, setNameError] = useState(false);

  const [titleErrorMsg, setTitleErrorMsg] = useState('');
  const [titleError, setTitleError] = useState(false);

  const [typeErrorMsg, setTypeErrorMsg] = useState('');
  const [typeError, setTypeError] = useState(false);

  const [footnoteErrorMsg, setFootnoteErrorMsg] = useState('');
  const [footnoteError, setFootnoteError] = useState(false);
  const [validationError, setValidationError] = useState('');

  const footnoteRef = useRef<HTMLInputElement>(null);

  const selectConceptsRef = useRef<any>();

  const [hasError, setHasError] = useState(false);

  const displayController = {
    not_displayed: 'not_displayed',
    display: 'display',
  };

  const [errorMsg, setErrorMsg] = useState(displayController.not_displayed);
  const typeRef = useRef<any>();
  useEffect(() => {
    fetchAndConvertToRankingDetail().then((response) => {
      if (response.source.title) {
        setTitle(response.source.title);
      }
      if (response.source.name) {
        setName(response.source.name);
      }
      if (response.source.footnote) {
        setFootnote(response.source.footnote);
      }
      if (response.source.ctaText) {
        setCtaText(response.source.ctaText);
      }

      if (response.source.title) {
        setTitle(response.source.title);
      }
      if (response.source.channelIds) {
        const initChannelIds: ChannelOption[] = response.source.channelIds.map(
          (channelId, index) => {
            return {
              value: channelId,
              label: channelOptions.find((v) => v.value === channelId)?.label,
            } as ChannelOption;
          },
        );
        setChannel(initChannelIds);
      }
      setItemId(response.source._id);
      setCustomeType(response.source.type as RankingListType);

      if (
        response.source.type == 'CUSTOMIZE' &&
        response.source.items.length > 0
      ) {
        setItemsList(response.source.items);
      }

      if (response.source.type == 'GENERIC' && response.source.concepts) {
        setConceptsId(response.source.concepts.map((v) => v.id));
      }

      setHotSearchType({
        value: response.source.type,
        label: response.source.type,
      } as TypeSelectOption);
    });
  }, [props.itemId]);

  console.log('RankingListPreviewProps', props);
  const [submitting, setSubmitting] = useState(false);

  const handleSelectChange = (
    newSelectOpts: MultiValue<{ label: string; value: any }>,
  ) => {
    console.log('Selected option:', newSelectOpts);
    if (newSelectOpts.length == 0) {
      setValidationError('concepts is empty');
      return;
    }
    setValidationError('');
    const cids: string[] = newSelectOpts.map((v) => {
      return v.value.id;
    });
  };

  const childRef = useRef<{ methodToCall: () => any }>(null);
  const callChildMethod = () => {
    if (childRef.current) {
      const childResult = childRef.current.methodToCall();
      return childResult;
    }
  };

  const checkType = () => {
    if (typeRef.current && typeRef.current.getValue().length === 0) {
      setTypeError(true);
      setTypeErrorMsg('type is empty');
      return false;
    } else {
      setTypeError(false);
      setTypeErrorMsg('');
    }
    return true;
  };

  const checkTitle = () => {
    if (titleRef.current && titleRef.current.value == '') {
      setTitleError(true);
      setTitleErrorMsg('title is empty');
      return false;
    } else {
      setTitleError(false);
      setTitleErrorMsg('');
    }
    return true;
  };

  const checkName2 = () => {
    if (nameRef.current && nameRef.current.value == '') {
      setNameError(true);
      setNameErrorMsg('name is empty');
      return false;
    } else {
      setNameError(false);
      setNameErrorMsg('');
    }
    return true;
  };

  const checkParams = () => {
    if (!checkType()) {
      return false;
    }

    if (!checkTitle()) {
      return false;
    }

    if (!checkName2()) {
      return false;
    }
    return true;
  };

  const checkItems = (itemsList: RankingItem[]) => {
    for (let i = 0; i < itemsList.length; i++) {
      const item = itemsList[i];
      if (item.isAddPortrait || !item.isLive) {
        if (item.image.portraitURL == '') {
          setHasError(true);
          setErrorMsg(
            'item product index, ' + (i + 1) + ' portraitURL is empty',
          );
          return false;
        }

        if (item.image.squarishURL == '') {
          setHasError(true);
          setErrorMsg(
            'item product index, ' + (i + 1) + ' squarishURL is empty',
          );
          return false;
        }

        if (item.title == '') {
          setHasError(true);
          setErrorMsg('item product index, ' + (i + 1) + ' title is empty');
          return false;
        }

        if (item.deepLink == '') {
          setHasError(true);
          setErrorMsg('item product index, ' + (i + 1) + ' deepLink is empty');
          return false;
        }
      } else {
        if (item.liveText == '') {
          setHasError(true);
          setErrorMsg('item product index, ' + (i + 1) + ' liveText is empty');
          return false;
        }

        if (item.liveText == '') {
          setHasError(true);
          setErrorMsg('item product index, ' + (i + 1) + ' liveText is empty');
          return false;
        }

        if (item.title == '') {
          setHasError(true);
          setErrorMsg('item product index, ' + (i + 1) + ' title is empty');
          return false;
        }

        if (item.deepLink == '') {
          setHasError(true);
          setErrorMsg('item product index, ' + (i + 1) + ' deepLink is empty');
          return false;
        }
      }
    }
    return true;
  };

  const submitChange = async () => {
    setSubmitting(true);
    if (!checkParams()) {
      setSubmitting(false);
      return;
    }

    let itemListResult: RankingItem[] = [];
    if (customeType == 'CUSTOMIZE' || hotSearchType?.value == 'CUSTOMIZE') {
      const aa = callChildMethod();
      console.log(aa);
      itemListResult = aa[0] as RankingItem[];

      if (!checkItems(itemListResult)) {
        setSubmitting(false);
        return;
      }

      const changeItemsResult = aa[1] as Record<string, ChangeItems>;
      const uploadImageItems = await uploadImagesBeforeSubmit(
        itemListResult,
        changeItemsResult,
      );
      // merge all upload portrait and squarish images
      for (const [key, value] of Object.entries(uploadImageItems)) {
        const currentIndex = value.itemIndex;
        const isPortrait = value.isPortrait;
        if (isPortrait) {
          itemListResult[currentIndex].image.portraitURL =
            value.imageUrl == null ? '' : value.imageUrl;
        }
        if (!isPortrait) {
          itemListResult[currentIndex].image.squarishURL =
            value.imageUrl == null ? '' : value.imageUrl;
        }
      }
      // merge all upload portrait and squarish images
      itemListResult.map((item, index) => {
        item.rank = index + 1;
        item.image.portraitURL =
          item.image.portraitURL == null ? '' : item.image.portraitURL;
        item.image.squarishURL =
          item.image.squarishURL == null ? '' : item.image.squarishURL;
      });
    }
    let selectConceptsIds: any = [];
    if (selectConceptsRef.current) {
      const values = selectConceptsRef.current.getValue() as SelectOption[];
      selectConceptsIds = values.map((value) => {
        const option = value.value as unknown;
        if (
          typeof option === 'object' &&
          option !== null &&
          'id' in option &&
          'name' in option
        ) {
          const optionSelect = option as ConceptOption;
          return optionSelect;
        }
      });
    }

    if (selectConceptsIds.length == 0 && hotSearchType?.value == 'GENERIC') {
      setValidationError('concepts is empty');
      setSubmitting(false);
      return;
    }

    console.log('start submitChange commit', selectConceptsRef);
    const params = {
      title: title,
      name: name,
      concepts: selectConceptsIds,
      footnote: footnote,
      items: itemListResult,
      ctaText: ctaText,
      channelIds: channel?.map((item, index) => {
        return item.value;
      }),
      type: customeType as RankingListType,
    } as RankingList;
    // if (props.mode === 'ADD' && hotSearchType) {
    params.type = customeType as RankingListType;
    // }
    try {
      const rr = await HotsearchClient.editAndAddRank(itemId, params, 'PATCH');
      if (rr.ok) {
        props.onDismiss();
        props.updateItem(
          props.mode == 'ADD' ? 'Add Content Success' : 'Edit Content Success',
        );
      } else {
        const data = await rr.json();
        if (data.error) {
          setErrorMsg(
            data.error[0].path[0]
              ? data.error[0].path.join(' ') + ' ' + data.error[0].message
              : data.error[0].message + ' is error',
          );
        } else {
          setErrorMsg(data.message);
        }
        setHasError(true);
        setSubmitting(false);
      }
    } catch (error) {
      setSubmitting(false);
      console.error(error);
      setErrorMsg(error as string);
      setHasError(true);
    }
  };

  async function fetchAndConvertToRankingDetail(): Promise<RankingDetail> {
    const response = await HotsearchClient.queryRankById(props.itemId);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const json: RankingDetail = await response.json();
    return json;
  }

  /***changed items index is portraitUrl or  */

  const uploadImagesBeforeSubmit = async (
    itemListResult: RankingItem[],
    changeItemsResult: Record<string, ChangeItems>,
  ) => {
    const squarishImageIds = [];
    const portraitImageIds = [];
    for (const key in changeItemsResult) {
      const uploadItem = changeItemsResult[key];
      if (uploadItem.image) {
        const imageId = uploadItem.image.id;
        uploadItem.isPortrait
          ? portraitImageIds.push(imageId)
          : squarishImageIds.push(imageId);
      }
    }
    // start get squarish presignedUrls
    if (squarishImageIds.length > 0) {
      const params: ImageIdsParams = {
        imageIds: squarishImageIds,
        imageType: 'squarish',
      };
      try {
        const response = await HotsearchClient.getImageUrlsByIds(params);
        console.log('get signedUrls:', response);
        for (const key in changeItemsResult) {
          const uploadItem = changeItemsResult[key];
          if (uploadItem.image) {
            const imageId = uploadItem.image.id;
            const preSignedUrls = response.preSignedUrls.filter((v) => {
              return v.imageId === imageId;
            });
            if (preSignedUrls.length > 0) {
              uploadItem.imageUrl = imageId;
              uploadItem.preSignedUrl = preSignedUrls[0].url;
            }
            console.log('uploadItem', uploadItem);
            changeItemsResult[key] = uploadItem;
          }
        }
      } catch (error) {
        console.error(error);
        setErrorMsg(error as string);
        setHasError(true);
      }
    }

    // start get portrait presignedUrls
    if (portraitImageIds.length > 0) {
      const params: ImageIdsParams = {
        imageIds: portraitImageIds,
        imageType: 'portrait',
      };
      try {
        const response = await HotsearchClient.getImageUrlsByIds(params);
        for (const key in changeItemsResult) {
          const uploadItem = changeItemsResult[key];
          if (uploadItem.image) {
            const imageId = uploadItem.image.id;
            const preSignedUrls = response.preSignedUrls.filter((v) => {
              return v.imageId === imageId;
            });
            if (preSignedUrls.length > 0) {
              uploadItem.imageUrl = imageId;
              uploadItem.preSignedUrl = preSignedUrls[0].url;
            }
            console.log('uploadItem', uploadItem);
            changeItemsResult[key] = uploadItem;
          }
        }
      } catch (error) {
        console.error(error);
        setErrorMsg(error as string);
        setHasError(true);
      }
    }
    console.log('end', changeItemsResult);

    //start upload all image fies to aws
    const promises: Promise<Response>[] = [];
    for (const key in changeItemsResult) {
      const item = changeItemsResult[key];
      if (!item.image) {
        continue;
      }
      const uploadWorks = HotsearchClient.uploadImage(
        item.preSignedUrl as string,
        item.image.files[0],
      );
      promises.push(uploadWorks);
    }
    await Promise.all(promises);
    //setChangeItems(changeItems);
    return changeItemsResult;
  };

  const onDismiss = () => {
    // is click close button isClickClosed
    //refreshItem(true);
    props.onDismiss();
  };

  // if (itemsList.length == 0) {
  //   return <>
  //     loading
  //   </>
  // }

  return (
    <>
      <Modal
        className='ranking-list-preview-modal'
        onDismiss={onDismiss}
        headerSlot={
          <h3 className='tw-text-lg tw-font-medium tw-text-center tw-bottom-2'>
            {props.mode == 'ADD'
              ? 'Add Ranking Content'
              : 'Edit Ranking Content'}
          </h3>
        }
        isOpen={props.showModal}
      >
        <div className='tw-flex-row tw-pr-4'>
          {/* type sort */}
          <div className='tw-flex tw-gap-8 tw-mt-4'>
            <span style={{ padding: '10px' }} className='tw-h-10 tw-w-14'>
              Type
            </span>
            <div className='tw-flex tw-w-[35rem] tw-justify-between'>
              <div
                className='tw-h-10 tw-text-[1.125rem] tw-font-medium tw-center'
                style={{ paddingTop: '10px' }}
              >
                {customeType == 'CUSTOMIZE'
                  ? 'HOT SEARCH'
                  : customeType
                  ? 'PRODUCT'
                  : ''}
              </div>
              {/* add start */}
              {/* add end */}
            </div>
          </div>

          {/* title */}
          <div className='tw-flex tw-gap-8 tw-mt-4'>
            <span style={{ padding: '12px' }} className='tw-h-10  tw-w-14'>
              Title
            </span>
            <TextField
              id='id'
              type='text' // default type
              label='Label'
              subtitle=''
              hideLabel
              hasErrors={titleError}
              errorMessage={titleErrorMsg}
              placeholder=''
              style={{ width: '562.08px' }}
              value={title}
              ref={titleRef}
              onChange={(e) => {
                if (e.target.value == '') {
                  setTitleError(true);
                  setTitleErrorMsg('title is empty');
                } else {
                  setTitleError(false);
                  setTitleErrorMsg('');
                }
                setTitle(e.target.value);
              }}
            />
          </div>

          {/* name */}
          {customeType == 'GENERIC' && (
            <div className='tw-flex tw-gap-8 tw-mt-4  tw-w-full'>
              <span style={{ padding: '10px' }} className='tw-h-10 tw-w-14'>
                Name
              </span>
              <TextField
                id='id'
                type='text' // default type
                label='Label'
                subtitle=''
                hideLabel
                hasErrors={nameError}
                errorMessage={nameErrorMsg}
                placeholder=''
                style={{ width: '562.08px' }}
                ref={nameRef}
                value={name}
                onChange={(e) => {
                  if (e.target.value == '') {
                    setNameError(true);
                    setNameErrorMsg('name is empty');
                  } else {
                    setNameError(false);
                    setNameErrorMsg('');
                  }
                  setName(e.target?.value);
                }}
              />
            </div>
          )}

          {/* ConceptIds */}
          {customeType == 'GENERIC' && (
            <div className='tw-flex tw-gap-8 tw-mt-4'>
              <span style={{ padding: '10px' }} className='tw-h-10 tw-w-14'>
                Concept
              </span>
              <ConceptSelect
                conceptIds={conceptsId}
                onChange={handleSelectChange}
                selectConceptsRef={selectConceptsRef}
                validationError={validationError}
                searchableOnly={false}
              />
            </div>
          )}

          {/* Items */}
          {(customeType == 'CUSTOMIZE' ||
            hotSearchType?.value == 'CUSTOMIZE') && (
            <RankingListItem itemsList={itemsList} ref={childRef} />
          )}

          {/* footnote */}
          <div className='tw-flex tw-gap-8 tw-mt-4'>
            <span style={{ padding: '10px' }} className='tw-h-10 tw-w-14'>
              Footnote
            </span>
            <TextField
              id='id'
              type='text' // default type
              label='Label'
              subtitle=''
              hideLabel
              value={footnote}
              hasErrors={footnoteError}
              errorMessage={footnoteErrorMsg}
              placeholder=''
              ref={footnoteRef}
              style={{ width: '562.08px' }}
              onChange={(e) => {
                setFootnote(e.target.value);
              }}
            />
          </div>

          {/* ctaText start */}
          {customeType == 'GENERIC' && (
            <div className='tw-flex tw-gap-8 tw-mt-4'>
              <span style={{ padding: '10px' }} className='tw-h-10 tw-w-14'>
                CtaText
              </span>
              <TextField
                id='id'
                type='text' // default type
                label='Label'
                subtitle=''
                hideLabel
                value={ctaText}
                placeholder=''
                style={{ width: '562.08px' }}
                onChange={(e) => {
                  setCtaText(e.target.value);
                }}
              />
            </div>
          )}
          {/* ctaText end */}

          {/* Button */}
          <div className='tw-flex tw-gap-8 tw-mt-4 tw-mb-10'>
            <span
              style={{ padding: '10px' }}
              className='tw-h-10 tw-w-[35rem] tw-text-center'
            >
              <Button
                className='eds-button eds-button--primary eds-button--small'
                onClick={submitChange}
                disabled={submitting || !props.canWrite}
              >
                Save
              </Button>
            </span>
          </div>
        </div>
        <Snackbar style={{ left: '90%', top: '90%' }}>
          {errorMsg != displayController.not_displayed && (
            <Snack
              autoDismissDuration={5000}
              id='pw-error-notification'
              onDismiss={(_id) => {
                setErrorMsg(displayController.not_displayed);
              }}
              status={hasError ? 'error' : 'success'}
            >
              {errorMsg ? errorMsg : 'Success'}
            </Snack>
          )}
        </Snackbar>
      </Modal>
    </>
  );
}
